import Axios from "axios";

// Cálculo da folha de pagamento: folhas, férias, rescisões, lançamentos, configuração e tabelas legais.
class FolhaCalculoDataService {
  // ---------------------------------------------------------------- folhas
  getCalculos(params) {
    return Axios.get("folhaCalculos", { params });
  }

  getCalculo(id) {
    return Axios.get(`folhaCalculos/${id}`);
  }

  getElegiveis(id) {
    return Axios.get(`folhaCalculos/${id}/elegiveis`);
  }

  getDemonstrativo(id) {
    return Axios.get(`folhaCalculos/demonstrativos/${id}`);
  }

  getResumoPdf(id) {
    return Axios.get(`folhaCalculos/${id}/resumo/pdf`, {
      responseType: "blob",
    });
  }

  // analitica, liquidos, encargos, clientes ou recibos
  getRelatorioPdf(id, relatorio) {
    return Axios.get(`folhaCalculos/${id}/relatorios/${relatorio}/pdf`, {
      responseType: "blob",
    });
  }

  // Remessa CNAB 240 dos líquidos: conferência (contaBancaria, dataPagamento, reenviar) e o arquivo.
  getRemessa(id, params) {
    return Axios.get(`folhaCalculos/${id}/remessa`, { params });
  }

  gerarRemessa(id, pedido) {
    return Axios.post(`folhaCalculos/${id}/remessa`, pedido, {
      responseType: "blob",
    });
  }

  getPdf(demonstrativoId) {
    return Axios.get(`folhaCalculos/demonstrativos/${demonstrativoId}/pdf`, {
      responseType: "blob",
    });
  }

  getVinculos(funcionarioId, competencia) {
    return Axios.get(`folhaCalculos/vinculos/${funcionarioId}`, {
      params: { competencia },
    });
  }

  getAfastamentos(calculoId, funcionarioId) {
    return Axios.get(
      `folhaCalculos/${calculoId}/afastamentos/${funcionarioId}`
    );
  }

  inserirAfastamento(calculoId, funcionarioId, data) {
    return Axios.post(
      `folhaCalculos/${calculoId}/afastamentos/${funcionarioId}`,
      data
    );
  }

  excluirAfastamento(calculoId, funcionarioId, afastamentoId, data) {
    return Axios.delete(
      `folhaCalculos/${calculoId}/afastamentos/${funcionarioId}/${afastamentoId}`,
      { data }
    );
  }

  confirmarReincidencia(calculoId, funcionarioId, afastamentoId, data) {
    return Axios.put(
      `folhaCalculos/${calculoId}/afastamentos/${funcionarioId}/${afastamentoId}/reincidencia`,
      data
    );
  }

  abrir(data) {
    return Axios.post("folhaCalculos", data);
  }

  alterarDataPagamento(id, data) {
    return Axios.put(`folhaCalculos/${id}/dataPagamento`, null, {
      params: { data },
    });
  }

  excluirCalculo(id) {
    return Axios.delete(`folhaCalculos/${id}`);
  }

  calcular(id, funcionarioIds) {
    return Axios.post(`folhaCalculos/${id}/calcular`, funcionarioIds || []);
  }

  fechar(id, demonstrativoIds) {
    return Axios.post(`folhaCalculos/${id}/fechar`, demonstrativoIds || []);
  }

  reabrir(id, demonstrativoIds) {
    return Axios.post(`folhaCalculos/${id}/reabrir`, demonstrativoIds || []);
  }

  // ---------------------------------------------------------------- férias
  alterarPagamentoSaldo(id, data) {
    return Axios.put(`folhaCalculos/${id}/dataPagamentoSaldo`, null, {
      params: { data },
    });
  }

  getFerias(params) {
    return Axios.get("folhaFerias", { params });
  }

  // Funcionários para programar férias com início na data: params { inicio, dias, nome, matricula, semDesligados }.
  getCandidatosFerias(params) {
    return Axios.get("folhaFerias/candidatos", { params });
  }

  // Cria os afastamentos de férias em lote: { funcionarioIds, inicio, dias, abono }; resultado por funcionário.
  programarFerias(data) {
    return Axios.post("folhaFerias/programar", data);
  }

  // Custo das férias de vários funcionários, sem gravar nada: { funcionarioIds, inicio, dias, abono }.
  simularFerias(data) {
    return Axios.post("folhaFerias/simular", data);
  }

  calcularFerias(afastamentoId, data) {
    return Axios.post(`folhaFerias/${afastamentoId}/calcular`, data || {});
  }

  fecharFerias(afastamentoId) {
    return Axios.post(`folhaFerias/${afastamentoId}/fechar`);
  }

  reabrirFerias(afastamentoId) {
    return Axios.post(`folhaFerias/${afastamentoId}/reabrir`);
  }

  // Devolve o que mudou na folha mensal do funcionário (recalculada sem as férias).
  excluirFerias(afastamentoId) {
    return Axios.delete(`folhaFerias/${afastamentoId}`);
  }

  // ---------------------------------------------------------------- rescisões
  // params: { de, ate } (desligamento); sem eles, todas.
  getRescisoes(params) {
    return Axios.get("folhaRescisoes", { params });
  }

  // TRCT (Termo de Rescisão do Contrato de Trabalho); prévia enquanto a rescisão não estiver fechada.
  getTrct(id) {
    return Axios.get(`folhaRescisoes/${id}/trct`, { responseType: "blob" });
  }

  getRescisao(id) {
    return Axios.get(`folhaRescisoes/${id}`);
  }

  // params { semDesligados }: sem os funcionários de status desligado.
  getCandidatosRescisao(params) {
    return Axios.get("folhaRescisoes/candidatos", { params });
  }

  prepararRescisao(funcionarioId) {
    return Axios.get(`folhaRescisoes/preparar/${funcionarioId}`);
  }

  // Inclusão em lote (mesmo desligamento, motivo e aviso); resultado por funcionário.
  incluirRescisoesLote(data) {
    return Axios.post("folhaRescisoes/lote", data);
  }

  // Custo das rescisões de vários funcionários, sem gravar nada: { funcionarioIds, dataDesligamento, motivo, aviso }.
  simularRescisoes(data) {
    return Axios.post("folhaRescisoes/simular", data);
  }

  salvarRescisao(data) {
    return data.id
      ? Axios.put(`folhaRescisoes/${data.id}`, data)
      : Axios.post("folhaRescisoes", data);
  }

  calcularRescisao(id) {
    return Axios.post(`folhaRescisoes/${id}/calcular`);
  }

  fecharRescisao(id) {
    return Axios.post(`folhaRescisoes/${id}/fechar`);
  }

  reabrirRescisao(id) {
    return Axios.post(`folhaRescisoes/${id}/reabrir`);
  }

  excluirRescisao(id) {
    return Axios.delete(`folhaRescisoes/${id}`);
  }

  // ---------------------------------------------------------------- lançamentos
  getLancamentos(params) {
    return Axios.get("folhaLancamentos", { params });
  }

  getOpcoesLancamento(competencia) {
    return Axios.get("folhaLancamentos/opcoes", { params: { competencia } });
  }

  salvarLancamentos(lista) {
    return Axios.post("folhaLancamentos", lista);
  }

  excluirLancamento(id) {
    return Axios.delete(`folhaLancamentos/${id}`);
  }

  importarLancamentos(data) {
    return Axios.post("folhaLancamentos/importar", data);
  }

  importacaoLancamentosExcel(competencia, tipo) {
    const params = { competencia, tipo };
    const enviar = (acao, file) => {
      const payload = new FormData();
      payload.append("file", file);
      return Axios.post(`folhaLancamentos/import/${acao}`, payload, { params });
    };
    return {
      generateImportTemplate: () =>
        Axios.get("folhaLancamentos/import/template", {
          params,
          responseType: "blob",
        }),
      validateImport: (file) => enviar("validate", file),
      applyImport: (file) => enviar("apply", file),
    };
  }

  // Editar em massa: o Excel traz os lançamentos do filtro; linhas com código alteram (quantidade 0 exclui) e sem código incluem.
  edicaoLancamentosExcel(competencia, tipo) {
    const params = { competencia, tipo };
    const base = "folhaLancamentos/import/update";
    // "TODAS" nos seletores do assistente = sem filtro.
    const filtroApi = (filtro = {}) => ({
      busca: filtro.busca || null,
      verbaId: filtro.verbaId === "TODAS" ? null : filtro.verbaId ?? null,
      origem: filtro.origem === "TODAS" ? null : filtro.origem || null,
    });
    const enviar = (acao, file) => {
      const payload = new FormData();
      payload.append("file", file);
      return Axios.post(`${base}/${acao}`, payload, { params });
    };
    return {
      listImportRecords: (filtro, paginacao) =>
        Axios.post(`${base}/records`, filtroApi(filtro), {
          params: { ...params, ...paginacao },
        }),
      generateImportTemplate: ({ filtro } = {}) =>
        Axios.post(`${base}/template`, filtroApi(filtro), {
          params,
          responseType: "blob",
        }),
      validateImport: (file) => enviar("validate", file),
      applyImport: (file) => enviar("apply", file),
    };
  }

  // Exportação dos lançamentos da folha mensal para a Dexion: rubricas com a escolha salva e arquivos já gerados.
  getExportacaoDexion(competencia) {
    return Axios.get("folhaLancamentos/dexion", { params: { competencia } });
  }

  // Pedido da Dexion: { competencia, rubricas: [{ verbaId, exportar, campo }] }.
  salvarEscolhasDexion(pedido) {
    return Axios.put("folhaLancamentos/dexion/escolhas", pedido);
  }

  // O arquivo como vai sair, agrupado por rubrica, com os lançamentos que ficam de fora.
  conferirDexion(pedido) {
    return Axios.post("folhaLancamentos/dexion/conferencia", pedido);
  }

  // Arquivo da Dexion; as escolhas ficam salvas.
  exportarDexion(pedido) {
    return Axios.post("folhaLancamentos/dexion", pedido, {
      responseType: "blob",
    });
  }

  getFixos(params) {
    return Axios.get("folhaLancamentos/fixos", { params });
  }

  salvarFixo(data) {
    return Axios.post("folhaLancamentos/fixos", data);
  }

  excluirFixo(id) {
    return Axios.delete(`folhaLancamentos/fixos/${id}`);
  }

  // Valores mensais informados para as médias de férias, 13º e rescisão (substituem o da folha no mês e rubrica).
  getMediasInformadas(funcionarioId) {
    return Axios.get("folhaLancamentos/medias", { params: { funcionarioId } });
  }

  // [{ funcionarioId, competencia, verbaId, quantidade, valor, restaurar }]; restaurar volta a usar a folha do mês.
  salvarMediasInformadas(lista) {
    return Axios.post("folhaLancamentos/medias", lista);
  }

  // ---------------------------------------------------------------- rubricas
  // As rubricas são as verbas da folha (FuncionarioFolhaPagamentoVerba); a configuração fica no cadastro delas.
  getRubricas() {
    return Axios.get("funcionarioFolhaPagamentoVerbas/calculo");
  }

  // Papéis calculados pelo motor (salário, INSS, IRRF...) sem verba ativa.
  getPapeisSemVerba() {
    return Axios.get("funcionarioFolhaPagamentoVerbas/calculo/papeisSemVerba");
  }

  // Catálogos do eSocial usados nas telas da folha (ex.: motivos de desligamento).
  getCatalogos() {
    return Axios.get("folhaCalculos/catalogos");
  }

  // ---------------------------------------------------------------- configuração
  getConfiguracao() {
    return Axios.get("folhaConfiguracao");
  }

  salvarConfiguracao(data) {
    return Axios.put("folhaConfiguracao", data);
  }

  // ---------------------------------------------------------------- tabelas legais
  getTabelasLegais() {
    return Axios.get("folhaTabelasLegais");
  }

  getTabelasVigentes(params) {
    return Axios.get("folhaTabelasLegais/vigentes", { params });
  }

  salvarTabelaLegal(data) {
    return data.id
      ? Axios.put(`folhaTabelasLegais/${data.id}`, data)
      : Axios.post("folhaTabelasLegais", data);
  }

  excluirTabelaLegal(tipo, id) {
    return Axios.delete(`folhaTabelasLegais/${tipo}/${id}`);
  }

  copiarAnoTabelas(origem, destino) {
    return Axios.post("folhaTabelasLegais/copiarAno", null, {
      params: { origem, destino },
    });
  }

  // ---------------------------------------------------------------- retenção do INSS do funcionário
  getRetencaoInss(funcionarioId) {
    return Axios.get(`funcionarios/${funcionarioId}/retencaoInss`);
  }

  salvarRetencaoInss(funcionarioId, data) {
    return Axios.put(`funcionarios/${funcionarioId}/retencaoInss`, data);
  }
}

export default new FolhaCalculoDataService();
